import SitesPage from './sites-page';

export default SitesPage;